import type {
    PurchaseReconciliation,
    PurchaseReconciliationForm,
    PurchaseReconciliationQueryParam,
    PurchaseReconciliationVo
} from "../../../../common/types/purchaseReconciliation";
import type { Page } from "../../../../common/types/base/BaseEntity";
import { SIGN_ORIGIN } from "../../../../common/enum/common";
import httpRequest from "./index";
import { confirmable } from "@/api/legacy";
import { BaseService } from "@/api/baseService";
import { analysisState } from "@/api/legacy";

class PurchaseReconciliationService extends BaseService<
    PurchaseReconciliation,
    PurchaseReconciliationVo,
    PurchaseReconciliationQueryParam,
    PurchaseReconciliationForm
> {
    public async getListByProjectId(
        projectId: number,
        type: number,
        params: any
    ): Promise<Page<PurchaseReconciliation>> {
        const { data } = await this.service.get(`${this.path}/paging/project-id/${projectId}/type/${type}`, { params });
        return data;
    }

    // @ts-ignore
    async paging(params: PurchaseReconciliationQueryParam): Promise<PurchaseReconciliation[]> {
        const { data } = await this.service.get(`${this.path}/customPaging`, { params });
        data.list.forEach((item: PurchaseReconciliation) => {
            (item as any).sigingState = item.state;
            item.state = analysisState.getNormalState(item.state);
        });
        return data;
    }

    // @ts-ignore
    public async create(form: PurchaseReconciliationForm): Promise<PurchaseReconciliation[]> {
        const { data } = await this.service.post(`${this.path}`, form);
        return data;
    }

    // @ts-ignore
    public async update(id: number | string, form: PurchaseReconciliationForm): Promise<PurchaseReconciliation[]> {
        const { data } = await this.service.put(`${this.path}/${id}`, form);
        return data;
    }

    // @ts-ignore
    public async getInfo(id: string): Promise<PurchaseReconciliationVo> {
        const { data: info } = await this.service.get(`${this.path}/vo/${id}`);
        info.purchaseReconciliation.sigingState = info.purchaseReconciliation.state;
        info.purchaseReconciliation.state = analysisState.getNormalState(info.purchaseReconciliation.state);
        return info;
    }

    // 签署
    public async signing(id: string): Promise<{ pageUrl: string; ticket: string; errors: unknown[]; status: number }> {
        const { data } = await this.service.put(`${this.path}/signing/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    // 发起签署
    public async initiateSigning(
        id: string
    ): Promise<{ pageUrl: string; ticket: string; errors: unknown[]; status: number }> {
        const { data } = await this.service.put(`${this.path}/initiateSigning/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    // 驳回
    public async reject(id: string, reason: string): Promise<{ pageUrl: string; ticket: string }> {
        const { data } = await this.service.post(`${this.path}/reject`, {
            id,
            reason
        });
        return data;
    }
    /**
     * 作废对账
     */
    async startInvalid(id: number): Promise<{
        pageUrl: string;
        ticket?: string;
        errors: unknown[];
        status: number;
    }> {
        const { data } = await this.service.put(`${this.path}/invalid/${id}?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }
}

export const purchaseReconciliationService = new PurchaseReconciliationService("/purchase/reconciliation", httpRequest);
